import { ReportTrackers } from '@olxeu-a2b/ui/typings/safeDealTracking';
import trackingKeys from '../../tracking/trackingKeys';
import useSafeDealEventTracking from './useSafeDealEventTracking';
import useSafeDealSpecialDataTracking from './useSafeDealSpecialDataTracking';

const {
  deliverySafeDealReportFormInfoOkClick,
  deliverySafeDealReportFormDescrClick,
  deliverySafeDealReportFormPhotoClick,
  deliverySafeDealReportFormCancelClick,
} = trackingKeys.events;

export const useSafeDealReportFormTracking = (adId: string): ReportTrackers => {
  const specialDataTracking = useSafeDealSpecialDataTracking(adId);

  const trackReportFormInfoOkClick = useSafeDealEventTracking(
    deliverySafeDealReportFormInfoOkClick,
    adId,
  );

  const trackReportDescrClick = useSafeDealEventTracking(
    deliverySafeDealReportFormDescrClick,
    adId,
  );

  const trackReportFormPhotoClick = useSafeDealEventTracking(
    deliverySafeDealReportFormPhotoClick,
    adId,
  );

  const trackReportFormCancelClick = useSafeDealEventTracking(
    deliverySafeDealReportFormCancelClick,
    adId,
  );

  return {
    trackReportFormInfoOkClick,
    trackReportDescrClick,
    trackReportFormPhotoClick,
    trackReportFormCancelClick,
    specialDataTracking,
  };
};

export default useSafeDealReportFormTracking;
